<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch" autocomplete="off">
    <el-form-item label="商品ID">
      <el-input v-model="queryParam.goodsnum" type="textarea" placeholder="多个使用回车分割" autosize />
    </el-form-item>
    <el-form-item label="商品名称">
      <el-input v-model.trim="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <el-form-item label="供应商">
      <el-select
        v-model="queryParam.supplierids"
        filterable
        multiple
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="商品类目">
      <el-cascader
        placeholder="请选择商品类目"
        filterable
        v-model="queryParam.catalogid"
        :options="catalogData"
        :show-all-levels="false"
        :props="catalogQueryProps"
      />
    </el-form-item>
    <el-form-item label="开票类型">
        <el-select v-model="queryParam.taxtype" placeholder="开票类型">
          <el-option label="增值税专用发票" :value="1" />
          <el-option label="增值税普通发票" :value="2" />
          <el-option label="不开票" :value="3" />
        </el-select>
    </el-form-item>
    <el-form-item label="货源状态">
        <el-select v-model="queryParam.gsstatus" placeholder="货源状态">
          <el-option label="上架" :value="1" />
          <el-option label="下架" :value="2" />
        </el-select>
    </el-form-item>
    <el-form-item label="品牌名称">
      <el-select v-model="queryParam.brandid" 
        filterable 
        multiple         
        placeholder="选择品牌">
        <template v-for="item in brandData" :key="item.brandid">
          <el-option :label="item.name" :value="item.brandid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="成本价">
      <el-col :span="11">
        <el-form-item prop="lowcostprice1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowcostprice1" :min="0" :precision="2" controls-position="right" placeholder="最小值" class="rangeWidth" />
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowcostprice2">
          <el-input-number v-model="queryParam.lowcostprice2" :min="0" :precision="2" controls-position="right" placeholder="最大值" class="rangeWidth" />
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="市场价">
      <el-col :span="11">
        <el-form-item prop="lowmarketprice1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowmarketprice1" :min="0" :precision="2" controls-position="right" placeholder="最小值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowmarketprice2">
          <el-input-number v-model="queryParam.lowmarketprice2" :min="0" :precision="2" controls-position="right" placeholder="最大值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="商品折扣">
      <el-col :span="11">
        <el-form-item prop="lowdiscount1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowdiscount1" :min="0" :precision="2" :step="0.1" controls-position="right" placeholder="最小值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowdiscount2">
          <el-input-number v-model="queryParam.lowdiscount2" :min="0" :precision="2" :step="0.1" controls-position="right" placeholder="最大值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <!-- <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="商品状态">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item> -->
    <el-form-item>
      <el-button type="danger" @click="getListGoods"><el-icon class="elicon"><Search /></el-icon>查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="warning"
          @click="openGoodsTemp('goods:goodstemp')"
          v-hasPermission="['goods:goodstemp']"
          >商品过渡库</el-button
        >
        <el-button
          type="danger"
          @click="(dialog = true), doGoodsAdd()"
          v-hasPermission="['goods:add']"
          ><el-icon class="elicon"><Plus /></el-icon>新增商品</el-button
        >
        <el-button
          type="danger"
          @click="openImport('goods:import')"
          v-hasPermission="['goods:import']"
          ><el-icon class="elicon"><Upload /></el-icon>导入商品</el-button
        >
        <el-button
          type="danger"
          @click="openImport('goods:importEdit')"
          v-hasPermission="['goods:importEdit']"
          ><el-icon class="elicon"><Upload /></el-icon>批量导入修改</el-button
        >
        <el-button
          v-if="$store.state.user.checkStatus==2"
          type="primary"
          :loading="loadingexport" @click="doExportGoods"
          v-hasPermission="['goods:export']"
          ><el-icon class="elicon"><Download /></el-icon>{{loadingexport ? "处理中 ..." : "导出商品"}}</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionGoods"
        class="mainTable"
        row-key="goodsid"
        stripe
      >
        <el-table-column type="selection" width="55" />
       
        <el-table-column label="商品ID" prop="goodsnum" width="120"/>
        <el-table-column label="商品名称" prop="name" width="200"/>
        <el-table-column label="商品规格" prop="specification" width="120" />
        <el-table-column label="成本价" align="center" prop="goodsSuppliers[0].costprice" />
        <el-table-column label="市场价" align="center" prop="goodsSuppliers[0].marketprice"/>
        <el-table-column label="商品折扣" align="center" prop="goodsSuppliers[0].discount">
          <template #default="scope">
          <span v-text="(scope.row.goodsSuppliers[0].discount*100).toFixed(0) + '%'" />
          </template>
        </el-table-column>
        <el-table-column label="供应商" align="center" prop="goodsSuppliers[0].supplier.name"/>
        <el-table-column label="品牌" align="center" prop="brandname"/>
        <el-table-column label="类目" prop="catalogname" width="150"/>
        <el-table-column label="货源状态" align="center" prop="goodsSuppliers[0].status">
          <template #default="scope">
          <el-tag
              round
              :type="scope.row.goodsSuppliers[0].status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showGoodsStatus(scope.row.goodsSuppliers[0].status)"></span
            ></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="created" width="155">
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
              "
            ></span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="状态" prop="status">
            <template #default="scope">
              <el-switch
                :value="scope.row.status"
                :active-value="1"
                :inactive-value="2"
                size="small"
                @change="doGoodsStatus(scope.$index, scope.row, 'status')"
              />
            </template> -->
        <!-- </el-table-column> -->
        <el-table-column label="操作" fixed="right" width="130">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doGoodsEdit(scope.$index, scope.row)"
              v-hasPermission="['goods:edit']"
              >编辑</el-link
            >

            <el-link
              type="primary"
              size="small"
              @click="open('goods:view', scope.row)"
              v-hasPermission="['goods:view']"
              >供应商</el-link
            >

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此商品吗？"
              width="200px"
              @confirm="doGoodsDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <div>
        <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定批量删除商品吗？"
              width="200px"
              @confirm="doBatchGoodsDelete"
            >
              <template #reference>
                <el-button type="danger" v-hasPermission="['goods:batch']"><el-icon class="elicon"><Close /></el-icon>批量删除</el-button>
              </template>
            </el-popconfirm>
      </div>
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
          :hide-on-single-page="true"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="55%"
    @close="doGoodsClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="goodsFormRef"
        :model="goodsForm"
        :rules="rules"
        label-width="120px"
        autocomplete="off"
      >
        <el-form-item label="商品类目" prop="catalogid">
          <el-cascader
            style="width: 100%"
            placeholder="请选择商品类目"
            v-model="goodsForm.catalogid"
            :options="catalogData"
            :show-all-levels="false"
            :props="catalogProps"
            @change="getCatalog"
            ref="catalogCascaderRef"
          />
        </el-form-item>

        <el-form-item label="品牌" prop="brandid">
          <el-select
            style="width: 100%"
            v-model="goodsForm.brandname"
            filterable
            placeholder="选择品牌"
            @change="getBrand"
            ref="brandRef"
          >
            <template v-for="item in brandData" :key="item.brandid">
              <el-option :label="item.name" :value="item.brandid" />
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input
            v-model.trim="goodsForm.name"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item label="商品规格" prop="specification">
          <el-input
            v-model.trim="goodsForm.specification"
            placeholder="请输入商品规格"
          />
        </el-form-item>
        <el-form-item label="商品描述" prop="specification">
          <el-input
            v-model.trim="goodsForm.desc"
            type="textarea"
            autosize
            placeholder="请输入商品描述"
          />
        </el-form-item>
        <el-form-item label="税收编码" prop="taxcode">
          <el-input
            v-model.trim="goodsForm.taxcode"
            placeholder="请输入税收编码"
          />
        </el-form-item>
        <el-form-item label="税收分类名称" prop="taxsort">
          <el-input
            v-model.trim="goodsForm.taxsort"
            placeholder="请输入税收分类名称"
          />
        </el-form-item>
        <el-form-item label="国际条形码" prop="barcode">
          <el-input
            v-model.trim="goodsForm.barcode"
            placeholder="请输入国际条形码"
          />
        </el-form-item>
        <el-form-item label="电商评价数" prop="erate">
          <el-input
            v-model.trim="goodsForm.erate"
            placeholder="请输入电商评价数"
          />
        </el-form-item>
        <el-form-item label="电商链接" prop="elink">
          <el-input
            v-model.trim="goodsForm.elink"
            placeholder="请输入电商链接"
          />
        </el-form-item>
        <el-form-item label="产地" prop="producer">
          <el-input
            v-model.trim="goodsForm.producer"
            placeholder="请输入产地"
          />
        </el-form-item>
        <el-form-item label="备注1" prop="note1">
          <el-input
            v-model.trim="goodsForm.note1"
            type="textarea"
            autosize
            placeholder="请输入备注1"
          />
        </el-form-item>
        <el-form-item label="备注2" prop="note2">
          <el-input
            v-model.trim="goodsForm.note2"
            type="textarea"
            autosize
            placeholder="请输入备注2"
          />
        </el-form-item>

        <el-divider />
        <h1>供应商信息</h1>
        <el-card
          class="box-card"
          shadow="never"
          style="margin-bottom: 10px"
          v-for="(supplier, index) in goodsForm.goodsSuppliers"
          :key="supplier.gsid"
        >
          <template #header>
            <div class="card-header">
              <span>供应商信息（{{ index + 1 }}）</span>
              <el-icon
                @click.prevent="deleteSupplier(supplier)"
                style="float: right;cursor: pointer;"
                ><Close
              /></el-icon>
            </div>
          </template>
          <el-form-item
            label="供应商"
            :prop="'goodsSuppliers.' + index + '.supplierid'"
            :rules="{
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            }"
          >
            <el-select
              style="width:100%"
              v-model="supplier.supplierid"
              filterable
              placeholder="选择供应商"
            >
              <template v-for="item in supplierData" :key="item.supplierid">
                <el-option :label="item.name" :value="item.supplierid" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="供应商商品ID"
            :prop="'goodsSuppliers.' + index + '.sgoodsnum'"
          >
            <el-input
              v-model.trim="supplier.sgoodsnum"
              placeholder="请输入供应商商品ID"
            />
          </el-form-item>
          <el-form-item
            label="成本价"
            :prop="'goodsSuppliers.' + index + '.costprice'"
            :rules="[{
              required: true,
              message: '请输入成本价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.costprice"
              placeholder="请输入成本价"
            />
          </el-form-item>
          <el-form-item
            label="市场价"
            :prop="'goodsSuppliers.' + index + '.marketprice'"
            :rules="[{
              required: true,
              message: '请输入市场价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.marketprice"
              placeholder="请输入市场价"
            />
          </el-form-item>
          <!-- <el-form-item
            label="商品折扣"
            :prop="'goodsSuppliers.' + index + '.discount'"
            :rules="[{
              required: true,
              message: '请输入商品折扣，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.discount"
              placeholder="请输入商品折扣"
            />
          </el-form-item> -->
          <el-form-item
            label="发货地"
            :prop="'goodsSuppliers.' + index + '.delivery'"
          >
            <el-input
              v-model="supplier.delivery"
              placeholder="请输入发货地"
            />
          </el-form-item>
          <el-form-item
            label="发货快递"
            :prop="'goodsSuppliers.' + index + '.express'"
          >
            <el-input
              v-model="supplier.express"
              placeholder="请输入发货快递"
            />
          </el-form-item>
          <el-form-item
            label="货源状态"
            :prop="'goodsSuppliers.' + index + '.status'"
            :rules="{
              required: true,
              message: '请选择货源状态',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="supplier.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="2">下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="默认供应商"
            :prop="'goodsSuppliers.' + index + '.defstatus'"
            :rules="{
              required: true,
              message: '请选择默认供应商',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="supplier.defstatus" @change="changeDefaultStatus(index)">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-card>

        <el-button @click="addSupplier" type="danger">添加供应商</el-button>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doGoodsClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doGoodsSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
        
<script setup>
import { ref, onMounted,getCurrentInstance, nextTick  } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listGoods, saveGoods, getGoodsInfo, exportGoods, deleteGoods, deleteBatchGoods } from "@/api/goods";
import { listSupplier } from "@/api/supplier";
import { listCatalog } from "@/api/catalog";
import { listBrand } from "@/api/brand";
import util from "@/util/tool.js";
import storage from  "@/util/storage";


// import store from "@/store";

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("goodsPath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.goodsid },
    // query: { name: row.name },
  });
};
let openImport = (routeName)=>{
  router.push({
    name: routeName
  });
}

let openGoodsTemp = (routeName)=>{
  router.push({
    name: routeName
  });
}

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const goodsFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

let title = ref("新增商品");

const multipleSelection = ref([]);
const doSelectionGoods = (val) => {
  multipleSelection.value = val;
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  brandid: "",
  catalogid: "",
  supplierids: "",
  goodsnum: "",
  status: "",
  taxtype: "",
  gsstatus: "",
  lowcostprice1: null,
  lowcostprice2: null,
  lowmarketprice1: null,
  lowmarketprice2: null,
  lowdiscount1: null,
  lowdiscount2:null
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    taxpoint: "",
    status: "",
    taxtype: "",
    gsstatus: "",
    lowcostprice1: null,
    lowcostprice2: null,
    lowmarketprice1: null,
    lowmarketprice2: null,
    lowdiscount1: null,
    lowdiscount2:null
  };
  getListGoods();
};

const goodsForm = ref({
  goodsid: null,
  name: null,
  catalogid: null,
  catalogname: null,
  brandid: null,
  brandname: null,
  specification: "",
  supplierids: "",
  status: 1,
  desc: "",
  taxcode: "",
  taxsort: "",
  barcode: "",
  erate: "",
  elink: "",
  producer: "",
  note1: "",
  note2: "",
  goodsSuppliers: [
    {
        gsid:null,
        supplierid: null,
        sgoodsnum: "",
        costprice: null,
        marketprice: null,
        discount: null,
        delivery: "",
        express: "",
        status: 1,
        defstatus: 0
    },
  ],
});

const changeDefaultStatus = (index) => {
  goodsForm.value.goodsSuppliers.forEach((supplier,i) => {
    console.log('supplier---',supplier)
    console.log('index----i---',index,i)
    if (index != i) {
      goodsForm.value.goodsSuppliers[i].defstatus = 0
    }
  });
};

const catalogCascaderRef = ref()
const getCatalog = ()=> {
    //console.log(val)
    // console.log(catalogCascaderRef.value.getCheckedNodes()[0].label)
    // console.log(catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > '))
    goodsForm.value.catalogname = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')+'||'+catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > ');
    // goodsForm.value.catalogid = val.slice(-1) 
    //console.log('-catalogCascaderRef.value.-',catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(','))
    //goodsForm.value.catalogid = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')

}

let currentInstance = null
const brandRef = ref()
const getBrand = (selectedValue) => {
  nextTick(() => {
     // 这里不加nextTick会获取不到准确的值
    const {selectedLabel} = currentInstance.refs.brandRef
    goodsForm.value.brandname = selectedLabel
    goodsForm.value.brandid = selectedValue
  })
}

const addSupplier = () => {
  goodsForm.value.goodsSuppliers.push({
    supplierid: null,
    sgoodsnum: "",
    costprice: null,
    marketprice: null,
    discount: null,
    delivery: "",
    express: "",
    status: 1,
    defstatus: 0
  });
};
const deleteSupplier = (supplier) => {
  const index = goodsForm.value.goodsSuppliers.indexOf(supplier);
  if (index !== -1) {
    goodsForm.value.goodsSuppliers.splice(index, 1);
  }
};

const doBatchGoodsDelete = () => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的商品项');
    return false
  }

  let goodsid = []

  multipleSelection.value.forEach((goods) => {
    goodsid.push({goodsid:goods.goodsid})
  });

  console.log(goodsid)

  deleteBatchGoods(goodsid).then((res) => {
    if (res.data.code === 1) {
      getListGoods();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
  
};

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("goodsPath")
  if (query) {
    queryParam.value = query
  }

  currentInstance = getCurrentInstance();

  getListBrand();
  getListSupplier();
  getListCatalog();
  getListGoods();
});

//品牌列表API
const brandData = ref([]);
const brandReset = (brands) => {
  let dataTmp = [];
  brands.forEach((brand) => {
    brand.brandid = brand.brandid.toString();
    dataTmp.push(brand);
  });
  return dataTmp;
};
const getListBrand = () => {
  listBrand({ pageNo: 1, pageSize: 20000, status: 1 }).then((res) => {
    brandData.value = brandReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplier({ pageNo: 1, pageSize: 20000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//类目API
const catalogQueryProps = ref({
  checkStrictly: true,
  multiple: true,
  //expandTrigger: "hover",
  emitPath: false,
  value: "catalogid",
  label: "name",
});
const catalogData = ref([]);
const catalogProps = ref({
  //checkStrictly: true,
  //expandTrigger: "hover",
  emitPath: false,
  value: "catalogid",
  label: "name",
});
const catalogReset = (catalogs) => {
  let dataTmp = [];
  catalogs.forEach((catalog) => {
    catalog.catalogid = catalog.catalogid.toString();
    catalog.parentid = catalog.parentid.toString();
    dataTmp.push(catalog);
    catalogReset(catalog.children);
  });
  return dataTmp;
};
const getListCatalog = () => {
  listCatalog({ pageNo: 1, pageSize: 20000, status: 1 }).then((res) => {
    catalogData.value = catalogReset(res.data.extend.pages.list);
  });
};

const doGoodsAdd = () => {
  title.value = "新增商品";
  resetForm()
  // goodsForm.value.goodsSuppliers = [
  //     {
  //       gsid: null,
  //       supplierid: null,
  //       sgoodsnum: "",
  //       costprice: null,
  //       marketprice: null,
  //       discount: null,
  //       status: 1
  //     },
  //   ]
};

const doGoodsDelete = (index, obj) => {
  console.log(obj.goodsid.toString())
  deleteGoods(obj).then((res) => {
    if (res.data.code === 1) {
      getListGoods();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

const doGoodsEdit = (index, obj) => {
  // console.log(index,obj)
  title.value = "编辑商品";
  // goodsForm.value = obj;//直接赋值会出问题


  goodsForm.value.catalogname = obj.catalogid+'||'+obj.catalogname
  console.log(goodsForm.value.catalogname)

  let goodsid = obj.goodsid.toString()

  getGoodsInfo({ goodsid}).then((res) => {
    goodsForm.value = res.data.extend.goods;
    goodsForm.value.goodsid = res.data.extend.goods.goodsid.toString()
    let catalogids = (res.data.extend.goods.catalogid).split(',')
   // console.log('catalogids----',catalogids,catalogids[catalogids.length-1])
    goodsForm.value.catalogid = catalogids[catalogids.length-1]
    //console.log('goodsForm.value.catalogid---',goodsForm.value.catalogid)
    //goodsForm.value.catalogid = res.data.extend.goods.catalogid.toString()
    goodsForm.value.brandid = res.data.extend.goods.brandid.toString()

    let goodsSuppliers = res.data.extend.goods.goodsSuppliers;

    let dataTmp = [];

    goodsSuppliers.forEach((supplier) => {
        supplier.supplierid = supplier.supplierid.toString();
        supplier.gsid = supplier.gsid.toString();
        //supplier.status = supplier.gsstatus;
        // supplier.discount = supplier.costprice / supplier.marketprice;
        dataTmp.push(supplier);

    });
    goodsForm.value.goodsSuppliers = dataTmp
  });
};

const doGoodsClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  goodsFormRef.value.resetFields()
};

const resetForm = () => {
  goodsForm.value = {
    goodsid: null,
    name: null,
    catalogid: null,
    catalogname: null,
    brandid: null,
    brandname: null,
    specification: "",
    desc: "",
    taxcode: "",
    taxsort: "",
    barcode: "",
    erate: "",
    elink: "",
    producer: "",
    note1: "",
    note2: "",
    supplierids: "",
    status: 1,
    goodsSuppliers: [
      {
          gsid:null,
          supplierid: null,
          sgoodsnum: "",
          costprice: null,
          marketprice: null,
          discount: null,
          delivery: "",
          express: "",
          status: 1,
          defstatus: 0
      },
    ],
  };
};

const doGoodsSave = () => {
  goodsFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    goodsForm.value.catalogname = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')+'||'+catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > ');


    goodsForm.value.goodsSuppliers.forEach((supplier) => {
        supplier.discount = supplier.costprice / supplier.marketprice;
    });

    console.log(goodsForm.value.goodsSuppliers)
    


    saveGoods(goodsForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListGoods();
          doGoodsClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新用户状态
//   const doGoodsStatus = (index, obj) => {
//     let status = obj.status == 1 ? 2 : 1;
//     let data = { status, name: obj.name, goodsid: obj.goodsid.toString() };
//     tableData.value[index].status = status;
//     saveGoods(data);
//   };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListGoods();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListGoods();
};

//商品表API
const getListGoods = () => {
  storage.remove('goodsPath')
  
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.brandname = query.brandid?query.brandid.join(','):''
  query.supplierids = query.supplierids?query.supplierids.join(','):''
  query.catalogid = query.catalogid?query.catalogid.join(','):''
  delete query.brandid
  console.log(query)

  listGoods(query).then((res) => {//queryParam.value
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

// const getGoodsInfos = (goodsid)=>{
//     getGoodsInfo({ goodsid}).then((res) => {
//         console.log(res)
//     });
// }

const doExportGoods = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  //queryParam.value.pageSize = 5000;
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.brandname = query.brandid?query.brandid.join(','):''
  query.supplierids = query.supplierids?query.supplierids.join(','):''
  query.catalogid = query.catalogid?query.catalogid.join(','):''
  query.pageSize = 5000
  delete query.brandid

  exportGoods(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  loadingexport.value = true;
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};


const validateDecimal = (rule, value, callback) => {
  //   const reg = /^d*(?:.d{0,2})?$/;
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入商品名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "名称长度2到200",
      trigger: "blur",
    },
  ],
  catalogid: [
    {
      required: true,
      message: "请选择类目",
      trigger: "change",
    },
  ],
  brandid: [
    {
      required: true,
      message: "请选择品牌",
      trigger: "change",
    },
  ],
  specification: [
    {
      message: "请填写商品规格",
      trigger: "blur",
    },
    {
      min: 2,
      max: 100,
      message: "规格长度2到100",
      trigger: "blur",
    },
  ],
});
</script>